import AdvancedSettings from './AdvancedSettings.container';

export default AdvancedSettings;
